module.exports = __webpack_public_path__ + "img/pin-location.11c6be21.svg";